import React, { useEffect, useRef, useState } from 'react';
import BattleSprite, { spriteAnimDurationMs } from './BattleSprite';

const BattleSkillEffect = ({
  sheet,
  loop = false,
  untilMs = 0,
  onComplete,
  onExpired,
}) => {
  const [hidden, setHidden] = useState(false);
  const [armed, setArmed] = useState(false);
  const onCompleteRef = useRef(onComplete);
  const onExpiredRef = useRef(onExpired);

  useEffect(() => {
    onCompleteRef.current = onComplete;
    onExpiredRef.current = onExpired;
  });

  useEffect(() => {
    setHidden(false);
    setArmed(false);
    if (!sheet?.url) return undefined;
    let cancelled = false;
    const url = sheet.url.startsWith('/') ? sheet.url : `/${sheet.url}`;
    const img = new Image();
    img.onload = () => {
      if (!cancelled) setArmed(true);
    };
    img.onerror = () => {
      if (cancelled) return;
      setHidden(true);
      onCompleteRef.current?.();
    };
    img.src = url;
    return () => {
      cancelled = true;
    };
  }, [sheet?.url, untilMs]);

  useEffect(() => {
    if (!armed || !loop || !untilMs || untilMs <= Date.now()) return undefined;
    const delay = untilMs - Date.now();
    const timer = setTimeout(() => {
      setHidden(true);
      onExpiredRef.current?.();
    }, delay);
    return () => clearTimeout(timer);
  }, [armed, loop, untilMs]);

  useEffect(() => {
    if (!armed || loop || !sheet?.url) return undefined;
    const ms = spriteAnimDurationMs(sheet);
    const timer = setTimeout(() => {
      setHidden(true);
      onCompleteRef.current?.();
    }, ms);
    return () => clearTimeout(timer);
  }, [armed, loop, sheet?.url, sheet?.frameCount, sheet?.fps, sheet?.frameWidth, sheet?.frameHeight]);

  if (hidden || !sheet?.url || !armed) return null;

  return (
    <BattleSprite
      sheet={sheet}
      playing
      loop={loop}
      className="battle-skill-effect-sprite"
      fallbackLabel=""
      onImageError={() => {
        setHidden(true);
        onCompleteRef.current?.();
      }}
    />
  );
};

export default BattleSkillEffect;
